import Api from 'libs/api/index';

class Pages extends Api {
  constructor() {
    super('admin/pages/');
  }
}

export default Pages;
